export default __webpack_public_path__ + "static/media/notBackup.c7940fba.svg";